// extracted by mini-css-extract-plugin
module.exports = {"img":"Loading_img__26Ah8","content":"Loading_content__QxJkm","content1":"Loading_content1__3RWg4","conteiner":"Loading_conteiner__u8bC7"};